import { useState } from 'react'
import { Link, Navigate } from 'react-router-dom'

import { useAuth } from '../auth/AuthProvider'
import { MarketPageHeader } from '../components/MarketPageHeader'
import { InventoryConnectionSettings } from '../components/settings/InventoryConnectionSettings'
import { useActiveVenue } from '../venues/ActiveVenueProvider'
import { isDemoStandEnabled } from './demoStand'
import { resetDemoInventory } from './inventory-demo-data'
import { InventoryDemoNotice } from './InventoryDemoNotice'

export function DemoIikoScreen() {
  const { session } = useAuth()
  const { activeVenueId } = useActiveVenue()
  const [revision, setRevision] = useState(0)
  if (!isDemoStandEnabled()) return <Navigate to="/my-prices" replace />

  return (
    <section className="market-page market-page--settings">
      <MarketPageHeader
        title="Демо подключения iiko"
        description="Пройдите подключение и синхронизацию на подготовленных данных."
      />
      <InventoryDemoNotice showConnectionLink={false} />
      <div className="market-actions-row">
        <Link className="echat-btn echat-btn--primary" to="/purchase">
          Открыть заказ по остаткам
        </Link>
        <button
          type="button"
          className="echat-btn echat-btn--ghost"
          disabled={session?.organizationId == null || activeVenueId == null}
          onClick={() => {
            if (session?.organizationId == null || activeVenueId == null) return
            resetDemoInventory({ organizationId: session.organizationId, venueId: activeVenueId })
            setRevision((current) => current + 1)
          }}
        >
          Пройти подключение с первого шага
        </button>
      </div>
      <InventoryConnectionSettings key={`${activeVenueId}:${revision}`} />
    </section>
  )
}
